import { InsuranceAgentExternalService } from "../services/insuranceAgentExternalService";
import { InsuranceAgentBaseStore } from "./insuranceAgentBaseStore";
import { GlobalStore } from "@roc/feature-app-core";

export class InsuranceAgentExternalStore extends InsuranceAgentBaseStore {
  constructor(globalStore: GlobalStore) {
    super(globalStore);
    this.insuranceAgentService = new InsuranceAgentExternalService();
  }
}